import Image from "next/image"
import React, { useCallback, useEffect, useState } from "react"

interface CustomImageType {
  src?: string
  width?: number
  height?: number
  className?: string
  fill: boolean
  objectFit?: string
}

const CustomImage = ({
  src = "",
  height,
  width,
  className,
  objectFit,
  fill = true,
}: CustomImageType) => {
  const [imgSrc, setImageSrc] = useState<string>("")

  useEffect(() => {
    if (src !== null) {
      setImageSrc(src)
    }
  }, [src])

  const ImageCallBack = useCallback(() => {
    return (
      <Image
        src={imgSrc ?? null}
        fill={fill}
        className={className}
        alt={"image"}
        height={height}
        width={width}
        priority
        objectFit={objectFit}
        onError={() => setImageSrc("../images/imagePlaceholder.svg")}
      />
    )
  }, [src, imgSrc])

  return ImageCallBack()
}
export default CustomImage
